import * as Yup from 'yup';
export const passwordResetRequestSchema = Yup.object().shape({
    email: Yup.string().required('E-mail jest wymagany').min(3, 'Fraza jest za krótka').email('Niepoprawny adres e-mail'),
});
